import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { ZigzinBanner } from '../components/ZigzinBanner';
import { useZigzinBanner } from '../services/useZigzinBanner';

export interface ZigzinBannerContainerProps {}

export const ZigzinBannerContainer: React.FC<React.PropsWithChildren<ZigzinBannerContainerProps>> = () => {
  const { is_hide, handleClick } = useZigzinBanner();

  if (is_hide) {
    return null;
  }

  return (
    <>
      <Divider />
      <ZigzinBanner onClick={handleClick} />
    </>
  );
};

const Divider = styled.div`
  width: 100%;
  height: 8px;
  background: ${vars.v3Color.gray100};
`;
